import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import { StoryElement } from "@quintype/components";
import Breadcrumb from "./../shared/breadcrumbs";
import { produce } from "immer";
import StoryMidPromotion from "../../storyMidContent";
import styles from "../text-story-page/styles.m.css";
import stylesVideo from "./styles.m.css";
import { VikatanResponsiveContainer } from "../../../../rows/ad-free";

class VideoStory extends Component {
  render() {
    const renderSidebar = get(this.props, ["renderSidebar"], () => null);
    const renderHeaderCard = get(this.props, ["renderHeaderCard"], () => null);
    const renderFooter = get(this.props, ["renderFooter"], () => null);
    const storyHeadline = get(this.props, ["story", "subheadline"], () => null);
    const cards = get(this.props, ["story", "cards"], []);

    let firstVideoElement;
    let firstVideoCard = {};

    for (let cardIterator = 0; cardIterator < cards.length; cardIterator++) {
      const foundVideo = cards[cardIterator]["story-elements"].find(
        ({ type, subtype }) => type === "youtube-video" || (type === "jsembed" && subtype === "dailymotion-video")
      );
      if (foundVideo) {
        firstVideoElement = foundVideo;
        firstVideoCard = cards[cardIterator];
        break;
      }
    }

    const renderHeaderVideo = () => {
      if (!firstVideoElement) {
        return null;
      }

      return (
        <div className={stylesVideo["header-video"]}>
          <StoryElement
            element={firstVideoElement}
            card={firstVideoCard}
            key={firstVideoElement.id}
            story={this.props.story}
          />
        </div>
      );
    };

    return (
      <div className="page-content">
        <div className={`container`}>
          <Breadcrumb story={this.props.story} config={this.props.config} />
        </div>
        <div className={`container ${styles["story-grid"]}`}>
          <div className={styles["main-content"]}>
            <article className={`${styles["story-body"]} ${stylesVideo["story-body"]} js-story`}>
              {renderHeaderCard()}
              {renderHeaderVideo()}
              <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
              {this.props.story.cards.map((card, index) => {
                const newCard = produce(card, draft => {
                  draft["story-elements"] = draft["story-elements"].filter(
                    element => element.id !== firstVideoElement.id
                  );
                });
                return (
                  <React.Fragment key={newCard.id}>
                    <VikatanResponsiveContainer
                      placement={"video-story"}
                      adtype={parseInt(index)}
                      story={this.props.story}
                      className="ad_300_250"
                    />
                    {index === 1 && <StoryMidPromotion story={this.props.story} />}
                    <StoryCard card={newCard} story={this.props.story} />
                  </React.Fragment>
                );
              })}

              {renderFooter()}
            </article>
          </div>
          {renderSidebar()}
        </div>
      </div>
    );
  }
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
VideoStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { VideoStory };
